// extracted by mini-css-extract-plugin
export var close = "notices-module--close--7da9a";
export var content = "notices-module--content--f1e05";
export var icon = "notices-module--icon--8f7e0";
export var integratedNotice = "notices-module--integrated-notice--57d04";
export var noLeftPadding = "notices-module--no-left-padding--62a18";
export var notice = "notices-module--notice--0f688";
export var row = "notices-module--row--96ad7";
export var text = "notices-module--text--fa25b";